import React from "react";
import "./Fitfun.css";
import smartWatch from "../../assets/smartWatch.png";
import fitfundemo from "../../assets/fitfun-demo.gif";

const Fitfun = () => {
  return (
    <>
      <div className="fit-section ">
        <div className="fit-about">
          <h3>
            <span>FitFun Smartwatch App</span>
          </h3>
          <p className="fit-about-status">
            FitFun App is a fitness smartwatchApp aimed at encouraging
            overweight people to enagage in consistent excercises. It also
            recommends workout options to users based on their personal
            information and fitness goals. Click{" "}
            <a
              href="https://www.figma.com/proto/JiZXJWRr9UIQmoLVkwrAAO/Fitness-Smartwatch-by-Sherefat-Onibile?node-id=17%3A213&scaling=scale-down&page-id=0%3A1&starting-point-node-id=17%3A213"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>{" "}
            to interact with the prototype.
          </p>
        </div>

        <div className="fit-content">
          <img
            src={smartWatch}
            alt="a pic displaying three smart watch interface"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      <div className="fit-section">
        <div className="fit-about">
          <h4>User Research</h4>
          <p className="fit-about-status">
            Many people have always struggled with loosing weight/keeping fit on
            a daily basis. I interviewed a couple of people who are about the
            ages of 25 to 50 and these were my deductions:
            <br />
            <br />
            <strong>Deductions:</strong>
            <br />
            Some people want to have fitness buddies virtually as the Pandemic
            has made it difficult to go to the gym.
            <br />
            Most people do not have time and are not discplined enough to
            workout on a daily basis.
            <br />
            Some users are not sure about the particular areas to focus on while
            trying to lose weight.
            <br />
            Some users are not aware of the quality and quantity of calories
            consumed on a daily basis.
            <br />
            Some users want just more than having notifications as reminders or
            reason to workout. <br />
            <br />
            <strong>Solution:</strong> <br />
            My Ideation was also to ask for what they enjoy doing at their
            leisure, incorporate it with their fitness goals so that it can be a
            reward system. Therefore, the more fitness achievements a user
            reaches, the higher he gets rewarded hence reason for the motivation
            feature.
            <br /> Furthermore, I also thought having a community of users whose
            fitness goals align will be another form of motivation that can make
            the user consistent.
            <br /> The Calorie counter is also a major tracking feature that
            helps the user to check their progress
          </p>
          <br />
        </div>
      </div>

      <div className="fit-section">
        <div className="fit-about">
          <h4>How it works</h4>
          <p className="fit-about-status">
            First Time Users are offered the option to activate Notification,
            which will pop up based on the frequency set by the User.
            <br />
            Whenever Notification pops up;
            <br />
            User can start by selecting workout options if they already know
            what to select and jump right at it. Any user who is not sure of the
            type of excercise to choose from can enter their details and the app
            is designed in a way to recommend suitable workout option(s) that
            match(es) their fitness goals based on details provided.
            <br /> A user is able to select workout and give it the duration of
            their choice and this is same for recommended workouts.Depending on
            the inputs, the user is motivated via badges, motivation which may
            include cinema ticket, game life. There is a direct variation
            between the volume of workout done by user and the value/ kind of
            motivation they get. This is to encourage users to remain consistent
            Everyday Users have a landing screen with the start button.
            <br />
            On the Right Hand side is a quick demo of how the App works . You
            can also click{" "}
            <a
              href="https://www.figma.com/proto/JiZXJWRr9UIQmoLVkwrAAO/Fitness-Smartwatch-by-Sherefat-Onibile?node-id=17%3A213&scaling=scale-down&page-id=0%3A1&starting-point-node-id=17%3A213"
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>{" "}
            to interact with the prototype designed with figma
          </p>
          <br />
        </div>
        <div className="fit-content">
          <img
            src={fitfundemo}
            alt="interactive design of fitfun app"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      <div className="fit-section">
        <div className="fit-about">
          <h4>Next Steps</h4>
          <p className="fit-about-status">
            The description below is how I planned to improve on the fitfun App
            in future based on the last user testing that I carried out. On the
            landing screen (the prototype starting point) the user is offered
            three app navigation choices:— <br />
            <strong>Options:</strong> Tapping on the exercises screen which has
            two buttons:
            <br />
            1.Select Workout button leading to a scrollable screen of several
            options including walk, yoga, cycle and swim.
            <br /> 2. Recommendations button leads to a vertically scrollable
            screen with several recommended exercises based on the user personal
            details entered into the app.
            <br />
            <br />
            <strong>Status:</strong> Tapping on the status button leads to the
            progress Status screen that have three choices buttons:
            <br />
            1.Statistics: Last exercise statistics which displays another screen
            with these including details about time spent and calories burnt for
            the particular exercise.
            <br /> 2. Calories counter : Tapping on this button opens a screen
            with graphic showing the amount burnt. <br />
            <br />
            <strong>Motivation:</strong> Tapping on the Motivation button leads
            to a screen with types of motivation incentives, including badges
            and rewards:
            <br />
            1. Badges button: tapping on this button opens the Badges screen
            showing assortments of Badges earned by the user doing exercises and
            burning calories. <br />
            2. Rewards button:Tapping on it opens a scrollable screen for
            various bonus rewards for the user for his progress in the fitness
            program he elected to follow.
            <br />
            3. Community button: By tapping on this one, a scrollable screen
            suggesting community groups that match his fitness goals and
            personal details. This design is still in progress and some
            functionalities need to be added so that it can become fully
            functional. The detailed badges, community, and calories(which
            displays calories consumed by user, and estimate calories of food
            that the user might want to consume) screen have not been finalized
            and this will be completed in the next phase of design.
          </p>
          <br />
        </div>
      </div>
    </>
  );
};

export default Fitfun;
